import React from "react";
import styles from "../../calendarDialog/PricingTooltip.module.scss";
import Clear from "@material-ui/icons/Clear";
import { withStyles } from "@material-ui/core/styles";
import { withTranslation } from "react-i18next";

const StyledClear = withStyles({
  root: {
    color: "#102b4e",
  },
})(Clear);

const LeasePricingTooltip = (props) => {
  return (
    <div onClick={props.closeTooltip}>
      <button data-testid="closeTooltip" className={styles.exitButton}>
        <StyledClear />
      </button>
      <div className={styles.header}>
        {props.t("PMRegistrationNumber.number")}
      </div>
      <div className={styles.bodyContent}>
        {props.t("PMRegistrationNumber.bodyText")}
      </div>
    </div>
  );
};

export default withTranslation("emp")(LeasePricingTooltip);
